/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import type { PartnerListModulePartner } from 'bundles/cds-labs/components/Modules/PartnerListModule';
import { PartnerListModule } from 'bundles/cds-labs/components/Modules/PartnerListModule';
import type { PromoTemplatePartnerListFragment } from 'bundles/promo-template/__generated__/contentfulTypes';

type Props = {
  content: PromoTemplatePartnerListFragment & {
    preloadImage?: boolean;
    removeTopPadding?: boolean;
    lazyLoadImage?: boolean;
  };
};

export function PartnerListModuleRenderer({ content }: Props) {
  const convertedPartners =
    content.partnersCollection?.items
      .map((partner): PartnerListModulePartner | null => {
        if (!partner) return null;
        const { description: partnerDescription, logo, name, sys, target } = partner;
        return {
          id: sys.id,
          description: partnerDescription,
          name,
          target,
          logo,
        };
      })
      .filter(Boolean) ?? [];
  const cta =
    content.ctaText && content.ctaTarget
      ? {
          label: content.ctaText,
          target: content.ctaTarget,
        }
      : null;

  const propsToChild = {
    ...content,
    partnersCollection: convertedPartners,
    cta,
  };

  return <PartnerListModule {...propsToChild} />;
}
